import {
	ColorPickerConfig,
	ColorPickerTypeEnum
}                from '@shared/components/color-picker/color-picker.model';
import { Color } from 'ngx-color';


export interface ICommonKeywordMetadata {
	colorPicker: ColorPickerConfig;
	emptyColor: Color;
}

export interface ICommonKeywordEntityMetadata extends ICommonKeywordMetadata {

	entity: {};

	i18n: {
		basepath: string;
		details: string;
		entity: string;
		form: string;
		page: string;
	};
}

export const COMMON_KEYWORD_METADATA: ICommonKeywordMetadata = {
	colorPicker: {
		preview: {
			type: ColorPickerTypeEnum.PREVIEW
		},
		slider: {
			type: ColorPickerTypeEnum.SLIDER,
			swatchCount: 4,
			swatchEndLightness: 70,
			swatchStartLightness: 30
		},
		swatches: {
			type: ColorPickerTypeEnum.SWATCHES,
			presetColors: [
				[ '#772828', '#A83838', '#C85B5B', '#D98C8C' ], // 0 deg (HSl hue)
				[ '#774F28', '#A87038', '#C8915B', '#D9B28C' ], // 30 deg (HSl hue)
				[ '#777628', '#A8A838', '#C8C85B', '#D9D98C' ], // 60 deg (HSl hue)
				[ '#4F7728', '#71A838', '#92C85B', '#B3D98C' ], // 90 deg (HSl hue)
				[ '#287728', '#38A839', '#5BC85B', '#8CD98D' ], // 120 deg (HSl hue)
				[ '#28774F', '#38A870', '#5BC891', '#8CD9B3' ], // 150 deg (HSl hue)
				[ '#287777', '#38A8A8', '#5BC8C8', '#8CD9D9' ], // 180 deg (HSl hue)
				[ '#284F77', '#3870A8', '#5B91C8', '#8CB3D9' ], // 210 deg (HSl hue)
				[ '#282877', '#3839A8', '#5B5BC8', '#8C8DD9' ], // 240 deg (HSl hue)
				[ '#4F2877', '#7138A8', '#925BC8', '#B38CD9' ], // 270 deg (HSl hue)
				[ '#772876', '#A838A8', '#C85BC8', '#D98CD9' ], // 300 deg (HSl hue)
				[ '#77284F', '#A83870', '#C85B91', '#D98CB2' ] // 330 deg (HSl hue)
			]
		}
	},
	emptyColor: {
		hex: null,
		rgb: null,
		hsl: null,
		hsv: null,
		oldHue: null,
		source: null
	}
};


export const COMMON_KEYWORD_ENTITY_METADATA: ICommonKeywordEntityMetadata = {
	...COMMON_KEYWORD_METADATA,
	entity: {},
	i18n: {
		basepath: 'keyword',
		details: 'details',
		entity: 'entity',
		form: 'form',
		page: 'page'
	}
};
